/*#__PURE__*/ export default {"key":"","type":"root","items":[{"key":"codeSnippets","def":[],"type":"list","listItemsType":"string"}]};